<template>
    <vx-table-row :data-test="`term-row-${props.term.id}`">
        <vx-table-row-title>
            <span class="text-xs sm:text-sm wrap-break-word max-w-[200px]">{{ props.term.title }}</span>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label>Status:</template>
            <vx-badge
                size="xs"
                :color="props.term.status === 'published' ? 'success' : 'slate'"
                data-test="status-badge"
            >
                {{ props.term.status === 'published' ? 'Published' : 'Draft' }}
            </vx-badge>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label>Effective At:</template>
            {{ formattedEffectiveAt }}
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label>Creator:</template>
            {{ props.term.creator?.name || '-' }}
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-dropdown v-if="props.term.status === 'draft'" placement="right">
                <vx-button type="button" color="muted" outline class="w-[45px]" :data-test="`menu-${props.term.id}`">
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item :data-test="`delete-${props.term.id}`" @click="emit('delete', props.term)">
                        Delete <font-awesome-icon widthAuto :icon="faTrash" />
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>

            <vx-button
                @click="acceptancesVisible = true"
                type="button"
                color="muted"
                outline
                :data-test="`acceptances-${props.term.id}`"
            >
                Acceptances
                <font-awesome-icon widthAuto :icon="faUsers" />
            </vx-button>

            <vx-button
                :href="editHref"
                type="button"
                color="muted"
                outline
                aria-label="Edit"
                :data-test="`edit-${props.term.id}`"
            >
                Edit
                <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>

        <term-acceptances-modal v-model:visible="acceptancesVisible" :team-id="props.teamId" :term="props.term" />
    </vx-table-row>
</template>

<script lang="ts" setup>
import {
    VxBadge,
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEllipsis, faFilePen, faTrash, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { computed, ref } from 'vue';
import { shortDateTime } from '~/utils/date';
import type { Term } from '~/services/adminTermsClient.types';
import TermAcceptancesModal from './TermAcceptancesModal.vue';

const props = defineProps<{
    teamId: number;
    term: Term;
}>();

const emit = defineEmits<{
    delete: [term: Term];
}>();

const acceptancesVisible = ref(false);

const formattedEffectiveAt = computed(() => shortDateTime(props.term.effective_at));

const editHref = computed(() => `/kiosk/teams/${props.teamId}/terms/${props.term.id}`);
</script>
